import React from 'react';
import PropTypes from 'prop-types';
import {
  PageSizerContainer,
} from './styledComponents';

/**
 * PageSizer Component documentation
 * @property       {string} className Name of the class to apply Styles to the component
 *
 */

function PageSizer(props) {
  const {
    children,
    className,
  } = props;
  return (
    <PageSizerContainer className={className}>
      {children}
    </PageSizerContainer>
  );
}

PageSizer.propTypes = {
  className: PropTypes.string,
};

PageSizer.defaultProps = {
  className: '',
};

export default PageSizer;



// WEBPACK FOOTER //
// ./src/components/PageSizer/index.js